import deepmerge from 'deepmerge';

const createPalette = ({
  type,
  grey20,
  grey60,
  grey200,
  grey800,
  grey700,
  white
}: any) => {
  if (type == 'light') {
    return {
      color1: white,
      color2: grey20,
      color3: grey60
    };
  }
  return {
    color1: grey800,
    color2: grey700,
    color3: grey200
  };
};

export const defaultContainer = {
  container1: {
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 0
  },
  container2: {
    borderWidth: '1px',
    borderBottomWidth: '2px',
    borderStyle: 'solid',
    borderRadius: 0
  }
}

const createOptions = ({
  color1,
  color3
}: any) => ({
  container1: {
    ...defaultContainer.container1,
    background: color1,
    borderColor: color3
  },
  container2: {
    ...defaultContainer.container2,
    background: color1,
    borderColor: color3
  }
});

const createGetContainer = (options: any) => ({ variant = 'container1' } = {}) =>
  options[variant];

export const createContainer = (palette: any, container = {}) => {
  const { getContainer: otherGetContainer, ...otherOptions }
    = typeof container == 'function' ? container(palette) : container;
  const containerPalette = createPalette(palette);
  const options = createOptions(containerPalette);
  const mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  return {
    getContainer: otherGetContainer || createGetContainer(mergedOptions),
    ...mergedOptions
  };
};
